"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _reactI18next = require("react-i18next");
var _uuid = require("uuid");
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _LabelModule = _interopRequireDefault(require("./Label.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["id", "htmlFor", "children", "required", "testAttr", "className", "useLabelElement", "i18nRequiredA11yLabel", "i18nRequiredVisualLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const Label = _ref => {
  let {
      id,
      htmlFor,
      children,
      required,
      testAttr,
      className,
      useLabelElement,
      i18nRequiredA11yLabel,
      i18nRequiredVisualLabel
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    current: El
  } = (0, _react.useRef)(useLabelElement ? 'label' : 'div');
  const {
    current: uuid
  } = (0, _react.useRef)((0, _uuid.v4)());
  const a11yId = id !== null && id !== void 0 ? id : uuid;
  const isAndroidDevice = _environment.default.isAndroid();
  const isSafariOnMac = _environment.default.isSafari() && !_environment.default.isTouchDevice();
  const shouldUseHiddenLabelText = !isAndroidDevice && !isSafariOnMac && useLabelElement && required;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(El, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    id: id,
    className: (0, _cnbuilder.cnb)(_LabelModule.default.root, className),
    htmlFor: htmlFor,
    "data-testid": testAttr
  }, !useLabelElement && {
    role: 'text'
  }), shouldUseHiddenLabelText && {
    'aria-labelledby': "".concat(a11yId, "-hidden-children")
  }), rest), {}, {
    children: [children, required && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "aria-hidden": true,
        children: i18nRequiredVisualLabel || t('ui:label.indicator')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _cnbuilder.cnb)(_LabelModule.default.required, 'visually-hidden'),
        children: i18nRequiredA11yLabel || t('ui:label.required')
      }), shouldUseHiddenLabelText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        id: "".concat(a11yId, "-hidden-children"),
        hidden: true,
        children: children
      })]
    })]
  }));
};
Label.defaultProps = {
  useLabelElement: true,
  testAttr: 'label'
};
var _default = exports.default = Label;